import { BiChevronLeft } from 'react-icons/bi'
import { Icon, IconProps, forwardRef } from '@chakra-ui/react'

export const OmChevronLeft = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} {...props} as={BiChevronLeft} />
))
